export const styles = {
  container_link:
    "cursor-pointer select-none inline-block",
};
